import React from 'react';
import { Box } from '@chakra-ui/react';

/**
 * Decorative lotus divider — static SVG line-work in the brand palette.
 * A centered lotus motif with fading flanking rules and diamond accents.
 */
const LotusDivider = ({ width = { base: '220px', md: '280px' }, opacity = 0.9, ...rest }) => (
  <Box w={width} mx="auto" opacity={opacity} {...rest} aria-hidden="true">
    <svg viewBox="0 0 280 44" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto' }}>
      <defs>
        <linearGradient id="lotus-line-l" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#ff9800" stopOpacity="0" />
          <stop offset="1" stopColor="#ff9800" stopOpacity="0.65" />
        </linearGradient>
        <linearGradient id="lotus-line-r" x1="1" y1="0" x2="0" y2="0">
          <stop offset="0" stopColor="#ff9800" stopOpacity="0" />
          <stop offset="1" stopColor="#ff9800" stopOpacity="0.65" />
        </linearGradient>
        <linearGradient id="lotus-petal" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffca28" />
          <stop offset="1" stopColor="#e56535" />
        </linearGradient>
      </defs>

      {/* Flanking rules */}
      <line x1="6" y1="22" x2="102" y2="22" stroke="url(#lotus-line-l)" strokeWidth="1" />
      <line x1="178" y1="22" x2="274" y2="22" stroke="url(#lotus-line-r)" strokeWidth="1" />

      {/* Diamond accents */}
      <path d="M108 22 L112 18 L116 22 L112 26 Z" fill="#ff9800" fillOpacity="0.7" />
      <path d="M164 22 L168 18 L172 22 L168 26 Z" fill="#ff9800" fillOpacity="0.7" />

      {/* Lotus — five petals over a base arc */}
      <g stroke="url(#lotus-petal)" strokeWidth="1.4" fill="none" strokeLinecap="round">
        {/* Center petal */}
        <path d="M140 8 C135 15, 135 23, 140 30 C145 23, 145 15, 140 8 Z" />
        {/* Inner side petals */}
        <path d="M140 30 C133 25, 128 18, 127 11 C133 15, 138 21, 140 27" />
        <path d="M140 30 C147 25, 152 18, 153 11 C147 15, 142 21, 140 27" />
        {/* Outer side petals */}
        <path d="M140 30 C130 28, 122 23, 118 16 C126 20, 135 25, 140 29" />
        <path d="M140 30 C150 28, 158 23, 162 16 C154 20, 145 25, 140 29" />
        {/* Base arc */}
        <path d="M124 33 C133 37.5, 147 37.5, 156 33" />
      </g>
    </svg>
  </Box>
);

export default LotusDivider;
